import { __extends as e } from "./index94.mjs";
var i;
(function(t) {
  t.MISSING_VALUE = "MISSING_VALUE", t.INVALID_VALUE = "INVALID_VALUE", t.MISSING_INTL_API = "MISSING_INTL_API";
})(i || (i = {}));
var s = (
  /** @class */
  (function(t) {
    e(n, t);
    function n(o, r, a) {
      var c = t.call(this, o) || this;
      return c.code = r, c.originalMessage = a, c;
    }
    return n.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, n;
  })(Error)
), I = (
  /** @class */
  (function(t) {
    e(n, t);
    function n(o, r, a, c) {
      return t.call(this, 'Invalid values for "'.concat(o, '": "').concat(r, '". Options are "').concat(Object.keys(a).join('", "'), '"'), i.INVALID_VALUE, c) || this;
    }
    return n;
  })(s)
), l = (
  /** @class */
  (function(t) {
    e(n, t);
    function n(o, r, a) {
      return t.call(this, 'Value for "'.concat(o, '" must be of type ').concat(r), i.INVALID_VALUE, a) || this;
    }
    return n;
  })(s)
), V = (
  /** @class */
  (function(t) {
    e(n, t);
    function n(o, r) {
      return t.call(this, 'The intl string context variable "'.concat(o, '" was not provided to the string "').concat(r, '"'), i.MISSING_VALUE, r) || this;
    }
    return n;
  })(s)
);
export {
  i as ErrorCode,
  s as FormatError,
  I as InvalidValueError,
  l as InvalidValueTypeError,
  V as MissingValueError
};
